import { createSelector } from 'reselect';

export const carsState = (state) => state.cars;

export const selectorFetching = createSelector(
  carsState,
  (state) => state.fetching,
);

export const selectorCars = createSelector(carsState, (state) => state.cars);

export const selectorCar = createSelector(carsState, (state) => state.car);
